.tablerIconify [stroke-width],
.tablerIconify [style*="stroke-width"],
.tablerIconify g,
.tablerIconify g * {
	stroke-width: var(--icon-stroke-width) !important;
}

.imageIcon {
	display: block;
	flex-shrink: 0;
	object-fit: contain;
}
